import { render, staticRenderFns } from "./Tor11.vue?vue&type=template&id=1421e70c&"
import script from "./Tor11.vue?vue&type=script&lang=js&"
export * from "./Tor11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports